/* eslint-disable no-else-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React, { useMemo } from "react";
import moment from "moment";
import Table from "../NewFriendTrend/Components/NewFriendTrendsTable";
import tableStyle from "../../../../theme/styles/table";
import styles from "./FriendsReportsTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";

const getDynamicCellWidths = (numberOfColumns) => {
  let structurePercent;

  if (numberOfColumns <= 2) {
    structurePercent = 40;
  } else if (numberOfColumns <= 4) {
    structurePercent = 35;
  } else if (numberOfColumns <= 6) {
    structurePercent = 30;
  } else if (numberOfColumns <= 8) {
    structurePercent = 25;
  } else {
    structurePercent = 20;
  }

  const dataPercent = (100 - structurePercent) / numberOfColumns;

  return {
    structure: `${structurePercent}%`,
    data: `${Math.max(dataPercent, 5)}%`,
  };
};

const getCellStyles = (widths) => ({
  structure: {
    width: widths.structure,
    minWidth: "150px",
    maxWidth: "300px",
    textAlign: "center",
    paddingLeft: "8px",
    paddingRight: "8px",
    borderRight: "1px solid #e0e0e0",
    fontWeight: "500",
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflow: "visible",
    lineHeight: "1.3",
  },
  data: {
    width: widths.data,
    minWidth: "50px",
    textAlign: "center",
    paddingLeft: "4px",
    paddingRight: "4px",
    borderRight: "1px solid #e0e0e0",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  header: {
    textAlign: "center",
    fontWeight: "600",
    backgroundColor: "#f5f5f5",
    borderBottom: "2px solid #1976d2",
    padding: "8px 4px",
    fontSize: "11px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    borderRight: "1px solid #e0e0e0",
  },
  structureHeader: {
    textAlign: "center",
    fontWeight: "600",
    backgroundColor: "#f5f5f5",
    borderBottom: "2px solid #1976d2",
    padding: "8px 8px",
    fontSize: "12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    borderRight: "1px solid #e0e0e0",
  },
  totalRow: {
    backgroundColor: "#f8f9fa",
    borderTop: "2px solid #1976d2",
    fontWeight: "600",
  },
});

const getDynamicColumns = (searchData) => {
  if (searchData && searchData.length > 0) {
    const { hierarchy } = searchData[0];
    return [
      {
        displayName: hierarchy ?? "Structure",
        key: "structure",
        isStructure: true,
      },
    ];
  }
  return [
    {
      displayName: "Structure",
      key: "structure",
      isStructure: true,
    },
  ];
};

const generateMonthColumns = (startDate, months) => {
  const monthColumns = [];
  let currentDate = moment(startDate);

  for (let i = 0; i < months; i++) {
    const monthKey = currentDate.format("MMM").toLowerCase();
    const displayMonth = currentDate.format("MMM YYYY");
    monthColumns.push({
      displayName: displayMonth,
      key: `${monthKey}fri`,
      isData: true,
    });
    currentDate = currentDate.add(1, "month");
  }

  return monthColumns;
};

const groupByStructureIdAndMonth = (data) => {
  const grouped = {};

  data.forEach((item) => {
    const date = new Date(item.generatedAt);
    const monthYear = `${date.toLocaleString("default", { month: "short" })} ${
      date.getFullYear() % 100
    }`;

    if (!grouped[item.structureId]) {
      grouped[item.structureId] = {};
    }

    if (!grouped[item.structureId][monthYear]) {
      grouped[item.structureId][monthYear] = {
        // structureName: item?.structureName,
        ...item,
        totalNewFriendCount: item.totalNewFriendCount,
      };
    }
  });

  return grouped;
};

const getUniqueMonths = (data) => {
  const uniqueMonths = new Set();

  data.forEach((item) => {
    const date = new Date(item.generatedAt);
    const monthYear = `${date.toLocaleString("default", { month: "short" })} ${
      date.getFullYear() % 100
    }`;
    uniqueMonths.add(monthYear);
  });

  const sortedMonths = Array.from(uniqueMonths).sort((a, b) => {
    const [monthA, yearA] = a.split(" ");
    const [monthB, yearB] = b.split(" ");

    const monthIndexA = new Date(`${monthA} 1, 20${yearA}`).getTime();
    const monthIndexB = new Date(`${monthB} 1, 20${yearB}`).getTime();

    return monthIndexA - monthIndexB;
  });

  return sortedMonths;
};

const getRows = ({ searchData, cellStyles }) => {
  const months = getUniqueMonths(searchData);
  const groupedData = groupByStructureIdAndMonth(searchData);

  const totals = {
    totalNewFriendCount: {},
  };

  months.forEach((month) => {
    totals.totalNewFriendCount[month] = 0;
  });

  const getDisplayStructureName = (item) => {
    const {
      hierarchy,
      areaName,
      zoneName,
      regionName,
      chapterName,
      districtName,
      structureName,
    } = item;

    switch (hierarchy) {
      case "AREA":
        return structureName;

      case "ZONE":
        return [areaName, structureName].filter(Boolean).join(" / ");

      case "REGION":
        return [areaName, zoneName, structureName].filter(Boolean).join(" / ");

      case "CHAPTER":
        return [areaName, zoneName, regionName, structureName]
          .filter(Boolean)
          .join(" / ");

      case "DISTRICT":
        return [areaName, zoneName, regionName, chapterName, structureName]
          .filter(Boolean)
          .join(" / ");

      case "BLOCK":
        return [
          areaName,
          zoneName,
          regionName,
          chapterName,
          districtName,
          structureName,
        ]
          .filter(Boolean)
          .join(" / ");

      default:
        return structureName || "NA";
    }
  };

  let dataArray = Object.keys(groupedData).map((structureId) => {
    const structureData = groupedData[structureId];
    const structureNames = new Set();
    Object.values(structureData).forEach((item) => {
      // if (item.structureName) {
      //   structureNames.add(item.structureName);
      // }
      structureNames.add(getDisplayStructureName(item));
    });
    const structure = Array.from(structureNames).join(", ") || "NA";

    return {
      structureId,
      structure,
      structureData,
    };
  });

  // Always sort A to Z
  dataArray = dataArray.sort((a, b) => {
    const nameA = a.structure.toLowerCase();
    const nameB = b.structure.toLowerCase();
    return nameA.localeCompare(nameB);
  });

  const rows = dataArray.map((item, index) => {
    const { structureId, structure, structureData } = item;
    const processedMonths = new Set();

    return (
      <TableRow
        style={{
          ...tableStyle.tableRow,
          "&:nth-of-type(even)": {
            backgroundColor: "#f9f9f9",
          },
          "&:hover": {
            backgroundColor: "#e3f2fd",
          },
        }}
        key={index}
      >
        <TableCell style={cellStyles.structure}>
          <Typography
            style={{
              ...styles.typoghrphyStyle,
              fontWeight: "500",
              color: "#1a1a1a",
              fontSize: "12px",
            }}
          >
            {structure}
          </Typography>
        </TableCell>
        {months.map((month) => {
          if (processedMonths.has(month)) {
            return null;
          }

          processedMonths.add(month);
          const monthData = structureData[month] || {};
          totals.totalNewFriendCount[month] +=
            monthData.totalNewFriendCount || 0;

          return (
            <React.Fragment key={`${structureId}-${month}`}>
              <TableCell style={cellStyles.data}>
                <Typography
                  style={{
                    ...styles.typoghrphyStyle,
                    fontWeight: "400",
                    color: "#1a1a1a",
                    fontSize: "11px",
                  }}
                >
                  {monthData.totalNewFriendCount || "0"}
                </Typography>
              </TableCell>
            </React.Fragment>
          );
        })}
      </TableRow>
    );
  });

  // Enhanced Total Row
  const totalRow = (
    <TableRow
      style={{
        ...tableStyle.tableRow,
        ...cellStyles.totalRow,
      }}
      key="total-row"
    >
      <TableCell
        style={{
          ...cellStyles.structure,
          ...cellStyles.totalRow,
        }}
      >
        <Typography
          style={{
            ...styles.typoghrphyStyle,
            fontWeight: "700",
            color: "#1976d2",
            fontSize: "12px",
          }}
        >
          Total
        </Typography>
      </TableCell>
      {months.map((month) => (
        <React.Fragment key={`total-${month}`}>
          <TableCell
            style={{
              ...cellStyles.data,
              ...cellStyles.totalRow,
            }}
          >
            <Typography
              style={{
                ...styles.typoghrphyStyle,
                fontWeight: "700",
                color: "#1976d2",
                fontSize: "11px",
              }}
            >
              {totals.totalNewFriendCount[month]}
            </Typography>
          </TableCell>
        </React.Fragment>
      ))}
    </TableRow>
  );
  rows.push(totalRow);
  return rows;
};

function ReportTable({ searchData }) {
  const { dateFrom, dateTo } = useMemo(() => {
    if (searchData && searchData.length > 0) {
      const dates = searchData.map((item) => moment(item.generatedAt));
      const minDate = moment.min(dates);
      const maxDate = moment.max(dates);
      return {
        dateFrom: minDate.format("YYYY-MM-DD"),
        dateTo: maxDate.format("YYYY-MM-DD"),
      };
    }
    return { dateFrom: null, dateTo: null };
  }, [searchData]);

  const calculateNumberOfMonths = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);

    if (!start.isValid() || !end.isValid()) {
      return 0;
    }

    return end.diff(start, "months") + 1;
  };

  const numberOfMonths = useMemo(
    () => calculateNumberOfMonths(dateFrom, dateTo),
    [dateFrom, dateTo]
  );

  // ✅ Improved dynamic cell styles
  const cellStyles = useMemo(() => {
    const widths = getDynamicCellWidths(numberOfMonths);
    return getCellStyles(widths);
  }, [numberOfMonths]);

  const REPORT_TABLE_COL = useMemo(() => {
    const dynamicColumns = generateMonthColumns(dateFrom, numberOfMonths);
    return [...getDynamicColumns(searchData), ...dynamicColumns];
  }, [dateFrom, numberOfMonths, searchData]);

  const rows = useMemo(() => {
    return getRows({ searchData, cellStyles });
  }, [searchData, cellStyles]);

  return (
    <div style={{ ...styles.container, overflow: "auto", width: "100%" }}>
      <style>
        {`
      /* ✅ Hide extra header row */
      .MuiTableHead-root tr:first-child {
        display: none !important;
      }
      
      /* ✅ TARGET THE SPECIFIC PROBLEMATIC CLASS */
      .css-5hcc88 {
        border-right: none !important;
      }
      
      /* ✅ Override any similar MUI generated classes */
      [class*="css-"][class*="hcc"] {
        border-right: none !important;
      }
      
      /* ✅ General MUI class override for borders */
      .MuiTableCell-root[class*="css-"] {
        border-right: 1px solid #e0e0e0 !important;
      }
      
      /* ✅ Fix structure column text display */
      .MuiTableCell-root:first-child {
        white-space: normal !important;
        word-wrap: break-word !important;
        overflow: visible !important;
        text-overflow: initial !important;
        max-width: none !important;
        min-width: 150px !important;
      }
      
      /* ✅ Keep data columns compact */
      .MuiTableCell-root:not(:first-child) {
        white-space: nowrap !important;
        overflow: hidden !important;
        min-width: 50px !important;
      }
      
      /* ✅ Remove last column border */
      .MuiTableCell-root:last-child,
      .css-5hcc88:last-child {
        border-right: none !important;
      }
      
      /* ✅ Fix header spacing */
      .MuiTableCell-root {
        padding: 6px 8px !important;
        vertical-align: middle !important; /* ✅ Center content vertically */
      }
      
      /* ✅ Make table responsive */
      .MuiTable-root {
        width: 100% !important;
        table-layout: auto !important; /* ✅ CHANGED: Allow flexible sizing */
        border-collapse: collapse !important;
      }
      
      /* ✅ Structure column specific styling */
      .MuiTableCell-root:first-child .MuiTypography-root {
        white-space: normal !important;
        word-break: break-word !important;
        line-height: 1.3 !important;
      }
      
      /* ✅ Remove tooltips */
      .MuiTypography-root {
        text-decoration: none !important;
        cursor: default !important;
      }
      
      /* ✅ Header alignment */
      .MuiTableHead-root .MuiTableCell-root {
        padding: 8px !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
      }
      
      /* ✅ Structure header full text */
      .MuiTableHead-root .MuiTableCell-root:first-child {
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: initial !important;
      }
      `}
      </style>
      <Table
        scrollable
        columns={REPORT_TABLE_COL}
        rows={rows}
        tableHeadCellStyle={(column) => ({
          ...styles.tableHeadCells,
          ...(column.isStructure
            ? cellStyles.structureHeader
            : cellStyles.header),
        })}
        searchData={searchData}
      />
    </div>
  );
}

export default ReportTable;
